// client/src/components/ProductSkeleton.js
import React from 'react';
import { Box, Card, CardContent, Skeleton, Container } from '@mui/material';

const SkeletonCard = () => (
  <Card sx={{ '&:hover': { borderColor: 'divider' } }}>
    <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 0 }} />
    <CardContent>
      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton variant="text" width="85%" height={26} />
      <Skeleton variant="text" width="55%" height={28} sx={{ mt: 1 }} />
    </CardContent>
    <Box sx={{ p: 2, pt: 0 }}>
      <Skeleton variant="rounded" height={36} />
    </Box>
  </Card>
);

// Shape-matched placeholder grid shown while the homepage's products load.
const ProductSkeleton = ({ count = 8 }) => (
  <Container maxWidth={false} sx={{ py: 4 }}>
    <Skeleton variant="rounded" height={420} sx={{ mb: 5, borderRadius: 4 }} />
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 2 }}>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </Box>
  </Container>
);

export default ProductSkeleton;
